import React, { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, useGSAP);

/** Thin accent progress bar pinned above the navbar, scrubbed to page scroll. */
const ScrollProgress: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      gsap.fromTo(
        ref.current,
        { scaleX: 0 },
        {
          scaleX: 1,
          ease: 'none',
          scrollTrigger: { start: 0, end: 'max', scrub: 0.3, invalidateOnRefresh: true },
        }
      );
    },
    { scope: ref }
  );

  return (
    <div
      ref={ref}
      aria-hidden='true'
      className='fixed top-0 left-0 right-0 h-[3px] z-[60] origin-left scale-x-0 pointer-events-none'
      style={{ background: '#ff2d00' }}
    />
  );
};

export default ScrollProgress;
